import axios from 'axios';

export const getTrackerAddress = async (lat, lng) => {
  const response = await axios.get(
    `https://nominatim.openstreetmap.org/reverse?format=jsonv2&lat=${lat}&lon=${lng}`
  );
  return response;
};
